export default {
	setModalState(state, { name, status = false, message = null, callback = null }) {
		// 傳入對應的名稱 狀態 訊息等
		state.name = name
		state.status = status
		state.message = message
		state.callback = callback
	},
	closeModal(state) {
		// 狀態false關閉
		state.status = false
	}
}
